import React from 'react'
import PropTypes from 'prop-types'
import TaskGroupContainer from './TaskGroupContainer'

const Task = ({
  match: {
    params: { taskGroupUuid },
  },
}) => {
  return <TaskGroupContainer taskGroupUuid={taskGroupUuid} />
}

Task.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      taskGroupUuid: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
}
export default Task
